import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "7",
  height: "14",
  viewBox: "0 0 7 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Vector",
      d: "M6 1L2 7L6 13",
      stroke: "#AA1E2D",
      "stroke-width": "2.25",
      "stroke-miterlimit": "10"
    }, null, -1)
  ]))]))
}
export default { render: render }